import { Spin } from "antd";
import React from "react";

function Loader() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexGrow: 1,
        height: "100vh",
      }}
    >
      <Spin />
    </div>
  );
}

export default Loader;
